import { Controller } from 'stimulus'
import './embedded_component.css'

export default class extends Controller {
  static targets = ['caret', 'headerContent', 'versionSwitcher']

  // Expand the attachment content when the version switcher is clicked.
  // Uses toggle (not show) so the paired angle-bracket icons swap correctly.
  expandContent() {
    const revealable = this.application.getControllerForElementAndIdentifier(
      this.element,
      'revealable'
    )
    if (!revealable) return

    // Only expand if currently collapsed — check the content target (non-icon)
    const contentTarget = revealable.toggleTargets.find(
      (elm) => !elm.classList.contains('js-no-animated-toggle')
    )
    if (!contentTarget || !revealable.isHidden(contentTarget)) return

    revealable.toggleTargets.forEach((elm) => revealable.toggleElement(elm))
  }

  // Called when any revealable toggle target is toggled (icons + content).
  // We only care about the content div (not the arrow icons).
  contentToggled(e) {
    if (e.target.classList.contains('js-no-animated-toggle')) return
    // headerContent / caret / versionSwitcher are only wired for PDFs together.
    if (!this.hasHeaderContentTarget || !this.hasVersionSwitcherTarget) return

    this.#animateVersionSwitcher(e.detail.visible)
  }

  #animateVersionSwitcher(show) {
    const el = this.versionSwitcherTarget
    this._versionSwitcherAnim?.cancel()

    if (show) {
      this.#setExpandedHeader(true)
      el.classList.remove('hidden')
      this._versionSwitcherAnim = el.animate(
        [
          { opacity: 0, transform: 'scale(0.92)' },
          { opacity: 1, transform: 'scale(1)' },
        ],
        { duration: 200, easing: 'ease-out' }
      )
    } else {
      this._versionSwitcherAnim = el.animate(
        [
          { opacity: 1, transform: 'scale(1)' },
          { opacity: 0, transform: 'scale(0.92)' },
        ],
        { duration: 150, easing: 'ease-in' }
      )
      this._versionSwitcherAnim.onfinish = () => {
        el.classList.add('hidden')
        this.#setExpandedHeader(false)
      }
    }
  }

  #setExpandedHeader(expanded) {
    this.headerContentTarget.classList.toggle('max-lg:flex-col', expanded)
    this.headerContentTarget.classList.toggle('max-lg:items-stretch', expanded)
    if (this.hasCaretTarget) {
      this.caretTarget.classList.toggle('max-lg:self-start', expanded)
    }
  }
}
